<template>
  <div class="sass_home">
    <div>
      <img src="@/assets/img/saas/banner.png" style="width:100%;height:408px;cursor:pointer" @click="openNew" />
    </div>
    <div class="page3" style="padding-top:20px;background:white">
      <div class="page2">
        <div class="page3title">
          <div style="height:1px;width:70px;border-top:2px solid #056ECA"></div>
          <div
            style="margin-left:22px;font-size:18px;font-weight:bold;color:#056ECA"
          >
            中控云的优势
          </div>
          <div
            style="margin-left:22px;height:1px;width:70px;border-top:2px solid #056ECA"
          ></div>
        </div>
        <div style="width:100%;text-align:center;height:30px;color:#676767">
          ADVANTAGE
        </div>
        <div class="page3body">
          <div class="page3body_advantage">
            <div class="advantage_borderall">
              <div class="advantage_border">
                <div
                  style="height:100px;width:100px;border-radius:50%;background:#F0F5FF;text-align:center;line-height:100px"
                >
                  <img src="@/assets/img/saas/低成本.png" />
                </div>
              </div>
            </div>
            <div
              style="width:100%;height:35px;text-align:center;line-height:35px;font-size:16px;color:#494949;font-weight:bold"
            >
              低成本
            </div>
            <div style="width:100%;text-align:center;height:100px;padding:10px">
              按实际使用需求购买服务，按年付费、按实际模弹性付费，减少大额资金占用
            </div>
          </div>
          <div class="page3body_advantage">
            <div class="advantage_borderall">
              <div class="advantage_border">
                <div
                  style="height:100px;width:100px;border-radius:50%;background:#F0F5FF;text-align:center;line-height:100px"
                >
                  <img src="@/assets/img/saas/快部署.png" />
                </div>
              </div>
            </div>
            <div
              style="width:100%;height:35px;text-align:center;line-height:35px;font-size:16px;color:#494949;font-weight:bold"
            >
              快部署
            </div>
            <div style="width:100%;text-align:center;height:100px;padding:10px">
              SaaS产品架构，云端部署实施购买账号就开通，最快1周投入使用
            </div>
          </div>
          <div class="page3body_advantage">
            <div class="advantage_borderall">
              <div class="advantage_border">
                <div
                  style="height:100px;width:100px;border-radius:50%;background:#F0F5FF;text-align:center;line-height:100px"
                >
                  <img src="@/assets/img/saas/易维护.png" />
                </div>
              </div>
            </div>
            <div
              style="width:100%;height:35px;text-align:center;line-height:35px;font-size:16px;color:#494949;font-weight:bold"
            >
              易维护
            </div>
            <div style="width:100%;text-align:center;height:100px;padding:10px">
              服务器由专业技术人员托管维护，技术服务人员实时在线，企业不需IT运维投入
            </div>
          </div>
          <div class="page3body_advantage">
            <div class="advantage_borderall">
              <div class="advantage_border">
                <div
                  style="height:100px;width:100px;border-radius:50%;background:#F0F5FF;text-align:center;line-height:100px"
                >
                  <img src="@/assets/img/saas/强安全.png" />
                </div>
              </div>
            </div>
            <div
              style="width:100%;height:35px;text-align:center;line-height:35px;font-size:16px;color:#494949;font-weight:bold"
            >
              强安全
            </div>
            <div style="width:100%;text-align:center;height:100px;padding:10px">
              系统构建在阿里云IoTPaaS平台，利用阿里云强大的云计算机能力和安全机制保证系统先进性，稳定性和信息安全
            </div>
          </div>
          <div class="page3body_advantage">
            <div class="advantage_borderall">
              <div class="advantage_border">
                <div
                  style="height:100px;width:100px;border-radius:50%;background:#F0F5FF;text-align:center;line-height:100px"
                >
                  <img src="@/assets/img/saas/易使用.png" />
                </div>
              </div>
            </div>
            <div
              style="width:100%;height:35px;text-align:center;line-height:35px;font-size:16px;color:#494949;font-weight:bold"
            >
              易使用
            </div>
            <div style="width:100%;text-align:center;height:150px;padding:10px">
              二十多年的工业企业服务经验积累，深度了解企业实际需求，贴近企业使用习惯，UI设计简单，操作易上手
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page3">
      <div class="page3title" style="background:white">
        <div style="height:1px;width:70px;border-top:2px solid #056ECA"></div>
        <div
          style="margin-left:22px;font-size:18px;font-weight:bold;color:#056ECA"
        >
          中控云的亮点
        </div>
        <div
          style="margin-left:22px;height:1px;width:70px;border-top:2px solid #056ECA"
        ></div>
      </div>
      <div
        style="width:100%;text-align:center;height:30px;color:#676767;background:white"
      >
        HIGHLIGHTS
      </div>
      <div class="page2" style="height:350px;">
        <div style="height:100%;width:57%;padding:30px;float:left">
          <img
            src="@/assets/img/saas/亮点.png"
            style="width:100%;height:100%"
          />
        </div>
        <div style="height:100%;width:43%;padding:20px;float:left">
          <div style="height:50px;width:100%">
            <div
              style="float:left;width:10%;height:50px;line-height:50px;text-align:center;display:flex; justify-content: center;align-items: center;"
            >
              <div
                style="width:17px;height:17px;border-radius:50%;background:#2A85D2"
              ></div>
            </div>
            <div style="width:100%;">
              <div
                style="font-size:17px;font-weight:bold;height:30px;line-height:35px;color:#3788D2"
              >
                纯B/S架构
              </div>
              <div>互联网web访问方式，无需安装客户端直接使用</div>
            </div>
          </div>
          <div style="height:50px;width:100%">
            <div
              style="float:left;width:10%;height:50px;line-height:50px;text-align:center;display:flex; justify-content: center;align-items: center;"
            >
              <div
                style="width:17px;height:17px;border-radius:50%;background:#2A85D2"
              ></div>
            </div>
            <div style="width:100%;">
              <div
                style="font-size:17px;font-weight:bold;height:30px;line-height:35px;color:#3788D2"
              >
                内置软件接口
              </div>
              <div>内置标准的ERP软件接口，如SAP、Oracle、用友、金蝶等</div>
            </div>
          </div>
          <div style="height:50px;width:100%">
            <div
              style="float:left;width:10%;height:50px;line-height:50px;text-align:center;display:flex; justify-content: center;align-items: center;"
            >
              <div
                style="width:17px;height:17px;border-radius:50%;background:#2A85D2"
              ></div>
            </div>
            <div style="width:100%;">
              <div
                style="font-size:17px;font-weight:bold;height:30px;line-height:35px;color:#3788D2"
              >
                低投资高回报
              </div>
              <div>按年租赁系统，比传统MES减低90%成本</div>
            </div>
          </div>
          <div style="height:50px;width:100%">
            <div
              style="float:left;width:10%;height:50px;line-height:50px;text-align:center;display:flex; justify-content: center;align-items: center;"
            >
              <div
                style="width:17px;height:17px;border-radius:50%;background:#2A85D2"
              ></div>
            </div>
            <div style="width:100%;">
              <div
                style="font-size:17px;font-weight:bold;height:30px;line-height:35px;color:#3788D2"
              >
                跨平台访问
              </div>
              <div>支持windows、Linux、IOS、Android一键访问</div>
            </div>
          </div>
          <div style="height:50px;width:100%">
            <div
              style="float:left;width:10%;height:50px;line-height:50px;text-align:center;display:flex; justify-content: center;align-items: center;"
            >
              <div
                style="width:17px;height:17px;border-radius:50%;background:#2A85D2"
              ></div>
            </div>
            <div style="width:100%;">
              <div
                style="font-size:17px;font-weight:bold;height:30px;line-height:35px;color:#3788D2"
              >
                资源选配灵活
              </div>
              <div>强大的资源选配平台，多个版本适用于不同层次需求</div>
            </div>
          </div>
          <div style="height:50px;width:100%">
            <div
              style="float:left;width:10%;height:50px;line-height:50px;text-align:center;display:flex; justify-content: center;align-items: center;"
            >
              <div
                style="width:17px;height:17px;border-radius:50%;background:#2A85D2"
              ></div>
            </div>
            <div style="width:100%;">
              <div
                style="font-size:17px;font-weight:bold;height:30px;line-height:35px;color:#3788D2"
              >
                可扩展性强
              </div>
              <div>适合工业4.0可扩张，可与企业设备深度集成</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page3" style="height:1200px;background:white">
      <div class="page2">
        <div class="page3title" style="background:white">
          <div style="height:1px;width:70px;border-top:2px solid #056ECA"></div>
          <div
            style="margin-left:22px;font-size:18px;font-weight:bold;color:#056ECA"
          >
            核心产品与服务
          </div>
          <div
            style="margin-left:22px;height:1px;width:70px;border-top:2px solid #056ECA"
          ></div>
        </div>
        <div
          style="width:100%;text-align:center;height:30px;color:#676767;background:white"
        >
          PRODUCTS AND SERVICES
        </div>
        <div style="height:30px;width:100%;text-align:right;line-height:30px;">
          <el-link :underline="false" type="info" @click="goSaaS()"
            >查看更多<i class="el-icon-d-arrow-right el-icon--right"></i
          ></el-link>
        </div>
        <div :style="{'height' :  dataList.length / 4 > 1 ? '760px' : '380px'}">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            :class="index % 4 !== 0 ? 'marginleft' : ''"
            style="height:380px;width:22.5%;background:#F5F5F5;float:left;margin-top:10px"
          >
            <div
              v-if="item.name"
              @mouseenter="enterSassbuttonshow(index + 1)"
              @mouseleave="leaveSassbuttonshow(index + 1)"
            >
              <div style="width:100%;height:240px;position:relative">
                <img :src="item.fileUrl" style="height:100%;width:100%;" />
                <div class="sasstitle">{{ item.name }}</div>
              </div>
              <div class="sasstitle1">{{ item.name }}</div>
              <div style="width:100%;height:60px" v-if="sassbuttonshow(index)">
                <el-button
                  round
                  @click="goDetail(item)"
                  style="margin-left:30px"
                  type="primary"
                  >查看详情</el-button
                >
                <el-button
                  round
                  style="margin-left:10px"
                  @click="goapply(item)"
                  type="primary"
                  >免费体验</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div style="height:270px;width:100%;margin-top:20px;">
          <div
            class="saasBackimg"
            @click="goRdms()"
            style="height:270px;width:48.5%;float:left;cursor:pointer"
          ></div>
          <div
            class="saasBackimgright"
            style="height:270px;width:48.5%;margin-left:2%;float:left"
          ></div>
        </div>
      </div>
    </div>
    <div class="page3" style="height:500px;background:white">
      <div class="page2">
        <div class="page3title" style="background:white">
          <div style="height:1px;width:70px;border-top:2px solid #056ECA"></div>
          <div
            style="margin-left:22px;font-size:18px;font-weight:bold;color:#056ECA"
          >
            选择中控
          </div>
          <div
            style="margin-left:22px;height:1px;width:70px;border-top:2px solid #056ECA"
          ></div>
        </div>
        <div
          style="width:100%;text-align:center;height:30px;color:#676767;background:white"
        >
          SUPCON
        </div>
        <div style="width:50%;float:left;height:350px;margin-top:20px">
          <div
            style="height:200px;width:100%;padding:20px;background:#F5F5F5;color:#696969;position: relative;"
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            中控技术股份有限公司（简称“中控技术”，688777.SH，SUPCON.SW）成立于1999年，是国内领先、全球化布局的智能制造整体解决方案供应商，并致力于“AI+数据”核心能力的构建及落地应用，已累计服务海内外客户3万多家，覆盖化工、石化、油气、电力、制药、冶金、建材、造纸、新材料、新能源、食品等数十个重点行业，公司核心产品被广泛应用在50多个国家和地区，为客户提供“AI+安全”“AI+质量”“AI+低碳”“AI+效益”的智能化解决方案，助力全球流程工业从传统生产制造模式向高度自动化、智能化转变，实现高质量可持续发展，为人类创造更加轻松美好的生活环境。
            <div
              style="width:20px;height:80px;background:#6077BC;position:absolute;right:-10px;top:60px"
            ></div>
          </div>
          <div style="height:80px;margin-top:20px;">
            <div style="float:left;width:22%;height:80px;text-align:center">
              <div style="font-weight:bold;font-size:25px">1999</div>
              <div style="margin-top:10px">中控技术成立</div>
            </div>
            <div
              style="float:left;width:1px;height:50px;border-right:1px solid #ccc;margin-top:7px"
            ></div>
            <div style="float:left;width:22%;height:80px;text-align:center">
              <div style="font-weight:bold;font-size:25px">3000+</div>
              <div style="margin-top:10px">全球员工数</div>
            </div>
            <div
              style="float:left;width:1px;height:50px;border-right:1px solid #ccc;margin-top:7px"
            ></div>
            <div style="float:left;width:26%;height:80px;text-align:center">
              <div style="font-weight:bold;font-size:25px">18000+</div>
              <div style="margin-top:10px">服务全球企业数</div>
            </div>
            <div
              style="float:left;width:1px;height:50px;border-right:1px solid #ccc;margin-top:7px"
            ></div>
            <div style="float:left;width:29%;height:80px;text-align:center">
              <div style="font-weight:bold;font-size:25px">30000+</div>
              <div style="margin-top:10px">DCS装置稳定运行套数</div>
            </div>
          </div>
        </div>
        <div
          style="width:45%;float:left;height:300px;margin-top:20px;margin-left:5%"
        >
          <img
            src="@/assets/img/saas/选择中控.png"
            style="width:100%;height:100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { openOther } from '@/utils'
export default {
  data () {
    return {
      userId: '',
      searchVisible: false,
      dataList: [],
      sassbuttonshow1: false,
      sassbuttonshow2: false,
      sassbuttonshow3: false,
      sassbuttonshow4: false,
      sassbuttonshow5: false,
      sassbuttonshow6: false,
      sassbuttonshow7: false,
      sassbuttonshow8: false
    }
  },
  mounted () {
    this.getSaasList()
  },
  methods: {
    sassbuttonshow (index) {
      return true
      // return this['sassbuttonshow' + (index + 1)]
    },
    // 跳转详情页
    goDetail (goods) {
      openOther(`goodDetail?spuId=${goods.spuId}`)
    },
    // 跳转申请试用页面
    goapply () {
      this.$router.push({
        name: 'applyUsed'
      })
    },
    enterSassbuttonshow (index) {
      this['sassbuttonshow' + index] = true
    },
    leaveSassbuttonshow (index) {
      this['sassbuttonshow' + index] = false
    },
    getSaasList () {
      this.$http
        .post(`/front/cross/commodity-user/web/spu-list`, {
          // resourceCode: 'KZXT',
          foregroundCategoryId: '489845345980506112',
          // resourceCode: 'SSFWG',
          page: 1,
          limit: 8
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data.dataList
            if (this.dataList.length > 8) {
              this.dataList.splice(0, 8)
            }
          }
        })
        .catch(() => {})
    },
    goList (code) {
      this.$router.push({
        name: 'saasList',
        query: {
          code: code
        }
      })
    },
    goSaaS (id) {
      if (!id) {
        id = '489845345980506112'
      }
      this.$router.push({
        name: 'goodCategoryList',
        query: {
          foregroundCategoryId: id,
          brandIdList: '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    },
    goRdms (id) {
      if (!id) {
        id = '464550135855828992'
      }
      this.$router.push({
        name: 'goodCategoryList',
        query: {
          foregroundCategoryId: id,
          brandIdList: '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    },
    jumpSoc () {
      this.userId = Cookies.get('userId')
      if (this.userId) {
        this.$http
          .get(`/front/consumer/order/soc/user/getSocUserStatus/` + this.userId)
          .then(data => {
            if (data) {
              if (data.data.data === 1) {
                this.$router.push({ name: 'securityConsole' })
              } else {
                this.searchVisible = true
                this.$message.error('您当前还未开通SOC安全服务')
              }
            }
          })
      }
    },
    openNew () {
      window.open('https://ecloud.supcon.com/', '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.sasstitle {
  position: absolute;
  height: 40px;
  width: 100%;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  color: white;
  font-size: 18px;
  text-align: center;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sasstitle1 {
  width: 100%;
  height: 80px;
  padding: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saasBackimg {
  background-image: url('../../../../assets/img/saas/RMDS.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.saasBackimgright {
  background-image: url('../../../../assets/img/saas/soc.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.sass_home {
  .page2 {
    width: 1190px;
    margin: 0 auto;
  }
}
.page3 {
  height: 430px;
  width: 100%;
}
.page3title {
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.page3body {
  width: 100%;
  height: 330px;
  .page3body_advantage {
    width: 20%;
    height: 330px;
    float: left;
    .advantage_borderall {
      height: 150px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      .advantage_border {
        height: 130px;
        width: 130px;
        border-radius: 50%;
        border: 1px solid #ccc;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 0px 10px #1f6eb6;
      }
    }
  }
}
.floor-top {
  width: 1190px;
}
.floor-one-left {
  color: #000;
  font-size: 26px;
  font-weight: normal;
}
.soc-list {
  width: 1190px;
  height: 300px;
  padding: 50px;
  background: #fff;
}
.soc-item {
  overflow: hidden;
}
.left {
  float: left;
  width: 300px;
  height: 200px;
  // background:red;
  border: #000 1px solid;
}
.right {
  float: left;
  margin-left: 30px;
}
.title {
}
.go-detail {
  margin-top: 120px;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: #000 1px solid;
  cursor: pointer;
}
.go-detail img {
  margin-left: 10px;
}
.marginleft {
  margin-left: 3%;
}
</style>
